import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints, P2PsportEndPoint, sportEndPoint } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  fetchAllData,
  updateData,
  getAllFilterData,
} from "../../../Utility/API";
import moment from "moment-timezone";
import { Modal, Form, Button } from "react-bootstrap";
import UserSearch from "../../../components/FilterComponent/UserSearch";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { GrEdit } from "react-icons/gr";
import { Delete } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import ListGroup from "react-bootstrap/ListGroup";
import Box from "@mui/material/Box";
//import Button from '@mui/material/Button';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Select from "@mui/material/Select";
import AddNote from "./Addnote";
import axios from "axios";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AccountStatusDialog from "./AccountStatusDialog";
import AccountTypeDialog from "./AccountTypeDialog";
import PlayerTypeDialog from "./PlayerTypeDialog";
import KycTypeDialog from "./KycTypeDialog";
import QuestionDialog from "./QuestionDialog";
import CRSTypeDialog from "./CRSTypeDialog";
import DailyLimitTypeDialog from "./DailyLimitTypeDialog";
import AddressInfoDialog from "./AddressInfoDialog";
import RGLimitDialogRaw from "./RGLimitDialogRaw";
import NotesList from "./NotesList";
import ContactInfo from "./ContactInfo";
import SecurityQuestion from "./SecurityQuestion";
import RGLimits from "./RGLimits";
import Transactions from "./Transactions";
import BetsCompetition from "./BetsCompetition";
import PlayerStatusDialog from "./PlayerStatusDialog";
import P2PBetsCompetition from "./P2PBetsCompetition";
import ReferFriendHistory from "./ReferFriendHistory";

const UserDetails = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userObject, setUserObject] = useState({});
  const params = useParams();

   

  const [accountDialog, setAccountDialog] = useState(false);
  const [accountValue, setAccountValue] = useState("");
  const [accountReason, setAccountReason] = useState("");
  const [openRGLimit, setOpenRGLimit] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [note, setNote] = useState("");
  const [openNote, setopenNote] = useState("");

  const [alldata, setalldata] = useState([]);
  const [addnote, setAddnote] = useState("");
  const [editData, setEditData] = useState({
  });

  const [getAccount, setGetAccount] = useState([]);
  const [linkAccount, setLinkAccount] = useState("");
  const [openlink, setOpenLink] = useState(false);

  const [accountTypeList, setAccountTypeList] = useState([
    {
      "account_status": "FINANCIAL",
      "id": 0
    },
    {
      "account_status": "ADMIN",
      "id": 1
    },
    {
      "account_status": "TESTUSER",
      "id": 2
    },
    {
      "account_status": "OPERATOR",
      "id": 3
    },
    {
      "account_status": "AGENCY",
      "id": 4
    },
    {
      "account_status": "REALUSER",
      "id": 5
    },

  ]);
  const [playerList, setPlayerList] = useState([]);
  const [playerStatusList, setPlayerStatusList] = useState([]);
  const [playerStatusModal, setPlayerStatusModal] = useState(false);
  const [playerStatusValue, setPlayerStatusValue] = useState("");
  const [playerDialog, setPlayerDialog] = useState(false);
  const [playerValue, setPlayerValue] = useState("");
  const [questionArr, setQuestionArr] = useState([]);
  const [questionValue, setQuestionValue] = useState("");
  const [ansValue, setAnsValue] = useState("");
  const [quesDailog, setQuesDialog] = useState(false);
  const [kycList, setKYCList] = useState([]);
  const [KYCDialog, setKYCDialog] = useState(false);
  const [kycValue, setKYCValue] = useState("");
  const [transArr, setTransArr] = useState([]);
  const [betArr, setBetArr] = useState([]);
  const [p2pbetArr, setP2PBetArr] = useState([]);
  const [addressDialog, setAddressDialog] = useState(false);
  const [rgLimitList, setRGLimitList] = useState([])

  const [crsLimitDialog, setCRSLimitDialog] = useState(false);
  const [crsLimit, setCRSLimit] = useState('');
  const [dayLimitDialog, setDayLimitDialog] = useState(false);
  const [dailyLimit, setDailyLimit] = useState('');

  const [userAccDialog, setUserAccDialog] = useState(false);
  const [userAccValue, setUserAccValue] = useState("");
  const state = useSelector((state) => state);
  const [tabvalue, setTabValue] = React.useState('1');

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  //console.log('state',state.auth?.user?.data?.type)
  const handleClose = (newValue,newReason) => {
    setAccountDialog(false);

    if (newValue) {
      setAccountValue(newValue);
      setAccountReason(newReason);
      let accountId = accountList.filter(
        (item) => item.account_status == newValue
      );
      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: accountId[0]?.id, //4
        userId: userObject.account?.userId,
        fieldName: "status",   
        reason: newReason
      };
      UpdateAccountUser(data);
    }
  };
  const UpdateAccountUser = (data) => {
    let url = `${endPoints.api.fieldUpdate}`;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchUserData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };
  const UpdateCommonInfo = (data) => {
    let url = `${endPoints.api.userFieldUpdate}`;
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);

        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchUserData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const handleRGLimitClose = (newValue) => {
    setOpenRGLimit(false);

  };

  const handleDepositClick = async (data) => {

    if (data?.rg_limit_value && data?.time_period) {
      let url = `${endPoints.api.userRGLimit}`;
      setIsLoading(true);
      let result = await addData(url, data);
      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setOpenRGLimit(false);
      setIsLoading(false);

    }
  }
  const coolOffUserClick = async (data) => {
    let url = `${endPoints.api.COOL_OFF}`;
    if (data?.time_period)
      setIsLoading(true);
    let result = await addData(url, data);

    if (result.data.status === "success") {
      SuccesToast(result?.data?.message);
      fetchUserData([]);
    }
    setOpenRGLimit(false);
    setIsLoading(false);

  }
  const excludeUserClick = async (data) => {
    let url = `${endPoints.api.USER_EXCLUDE}`;
    setIsLoading(true);
    let result = await addData(url, data);
    // debugger
    if (result.data.status === "success") {
      SuccesToast(result?.data?.message);
      fetchUserData([]);
    }
    setOpenRGLimit(false);
    setIsLoading(false);
  }
  const handleBetClick = async (data) => {
    if (data?.rg_limit_value && data?.time_period) {
      let url = `${endPoints.api.userRGLimit}`;
      setIsLoading(true);
      let result = await addData(url, data);
      // debugger
      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setOpenRGLimit(false);
      setIsLoading(false);

    }
  }
  const handleAccountTypeClose = (newValue) => {
    setUserAccDialog(false);
    if (newValue) {
      setUserAccValue(newValue);
      let playerId = accountTypeList.filter((item) => item.id == newValue);

      let data = {
        LoginUserId: state.auth?.user?.data?.idUser,
        fieldValue: playerId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "type",
      };
      // console.log('data',data)
      UpdateCommonInfo(data);
    }
  }

  const handlePlayerStatusClose = (newValue) => {
    setPlayerStatusModal(false);
    
    if (newValue) {
      setPlayerStatusValue(newValue);
      
      let playerId = playerStatusList.filter((item) => item.player_status == newValue);

      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: playerId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "player_status",
      };
      UpdateCommonInfo(data);
    }
  };

  const handlePlayerTypeeClose = (newValue) => {
    setPlayerDialog(false);
    if (newValue) {
      setPlayerValue(newValue);
      let playerId = playerList.filter((item) => item.player_type == newValue);

      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: playerId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "player_type",
      };
      UpdateCommonInfo(data);
    }
  };
  const handleKycTypeClose = (newValue) => {
    setKYCDialog(false);
    if (newValue) {
      setKYCValue(newValue);
      let kycId = kycList.filter((item) => item.kyc_status == newValue);

      let data = {
        idAccount: userObject.account?.idAccount,
        fieldValue: kycId[0]?.id,
        userId: userObject.account?.userId,
        fieldName: "kyc_status",
      };
      UpdateCommonInfo(data);
    }
  };

  const handleQuestionClose = async (newValue, newValueAns) => {
    setQuesDialog(false);
    if (newValue || newValueAns) {
      setQuestionValue(newValue);
      setAnsValue(newValueAns);
      let question = questionArr.filter((item) => item.question == newValue);
      let data = {
        idUser: userObject?.idUser,
        login: userObject?.login,
        personalQuestion: question[0]?.question_id,
        personalResponse: newValueAns
      }
      let url = `${endPoints.api.userSecret}`;
      setIsLoading(true);
      let result = await updateData(url, data);
      if (result.data.status === "success") {
        SuccesToast(result?.data?.message);
        fetchUserData([]);
      }
      setIsLoading(false);

    }
  };

  const handleCRSClose = async (newValue) => {
    setCRSLimitDialog(false);

    if (newValue) {
      setCRSLimit(newValue)
      let data = {
        //userId
        userId: userObject?.idUser,
        login: userObject?.login,
        fieldValue: newValue,
        fieldName: "crs_limit",
      }
      UpdateCommonInfo(data);

    }
  };

  const handleDailyLimitClose = async (newValue) => {
    setDayLimitDialog(false);

    if (newValue) {
      setDailyLimit(newValue)
      let data = {
        userId: userObject?.idUser,
        login: userObject?.login,
        fieldValue: newValue,
        fieldName: "day_limit",
      }
      UpdateCommonInfo(data);

    }
  };


  const handleAddressClose = () => {
    setAddressDialog(false);

  };

  
  const handleChangePage = (event , newPage) => {
    console.log("newpage",newPage);
    setPage(newPage);
    Usertransactions(newPage +1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);

  };

  const Usertransactions = async (page) => {
    let url = `${endPoints.api.transactions}/${params.userId}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllData(url)
        .then((response) => {
            setIsLoading(false);
            if (response.status === "success") {
                let data = response.data;
                console.log("Alldata",data);
                setTransArr(data);
                const ITEMS_PER_PAGE = rowsPerPage;
                setTotalCount(data[0]?.totalcount);
                // setTotalPages(totalPagesCount);
            } else {
            }
        })
        .catch((error) => {
            setIsLoading(false);
            console.error(error);
        });
};

useEffect(() => {
  Usertransactions(page);
}, []);

useEffect(() => {
  setPage(0);
  Usertransactions(page);
}, [rowsPerPage]);


  useEffect(() => {
    (async () => {
      let url = `${endPoints.api.GET_QUESTIONS}`;

      setIsLoading(true);
      let results = await getAllData(url);
      fetchBetsData();
      fetchP2PBetsData();


      if (results.status === "success") {
        setQuestionArr(results.data);
        fetchUserData(results.data);
      }
      // if (betResult.status === "success") {
      //   setBetArr(betResult.data);
      // }
      getPlayerTypes();
      getPlayerStatus();
      getAccountStatus();
      getKycTypes();
      getRgLimitTypes()
      setIsLoading(false);
    })();

    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  const getRgLimitTypes = () => {
    let url = `${endPoints.api.rgTypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setRGLimitList(data)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchBetsData = () => {
    let url = `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.User_BETS}/${params.userId}`; //&status=APPROVED
    fetchAllData(url)
      .then((res) => res.json())
      .then((response) => {
        setBetArr(response);
      })
      .catch((error)=>{
        console.log(error);
      });
  };

   const fetchP2PBetsData = () => {
    let url = `${P2PsportEndPoint.apiBaseUrl}${P2PsportEndPoint.api.USER_POOL_BETS}/${params.userId}`; //&status=APPROVED
    fetchAllData(url)
      .then((res) => res.json())
      .then((response) => {
        setP2PBetArr(response.data);
      })
      .catch((error)=>{
        console.log(error);
      });
  };

  const getKycTypes = () => {
    let url = `${endPoints.api.kycstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setKYCList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchUserData = async (questionList = []) => {
    let url = `${endPoints.api.GET_BY_USERID}/${params.userId}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          //setRows(response.data);
          setUserObject(response.data);
          // debugger
          setAccountValue(response?.data?.accountStatus || "");
          setAccountReason(response?.data?.account?.reason || "")
          setPlayerValue(response?.data?.playerType || "");
          setPlayerStatusValue(response?.data?.playerStatus || "")
          setKYCValue(response?.data?.kycStatus || "");
          setAnsValue(response?.data?.personalResponse || "");
          setUserAccValue(response?.data?.type)
          let questionName = questionList.filter(
            (item) => item.question_id == response.data.personalQuestion
          );

          if (questionName) {
            setQuestionValue(questionName[0]?.question || "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {

    Getnotes();

  }, []);


  const Getnotes = async (data) => {
    let url = `${endPoints.api.GET_NOTES}/${params.userId}`;
    // setIsLoading(true);
    await getAllData(url, data)
      .then((response) => {
        // setIsLoading(false);
        // console.log("data", response.data);
        setIsLoading(false);
        if (response.status === "success") {
          setalldata(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const DeleteNote = (id) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELETE_NOTE}/${id}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);

        // console.log("res", response);
        if (response.data.status === "success") {
          SuccesToast("Note Deleted Successfully.");
          Getnotes();
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const RemoveLinkAccount = (userid, linkid) => {
    const url = `${endPoints.apiBaseUrl}${endPoints.api.DELINK_ACCOUNT}`;
    const data = {
      id_user: userid,
      link_Id: linkid
    };

    setIsLoading(true);
    // console.log("Request Data:", data);

    axios.delete(url, {
      headers: {
        'Accept': '*/*'
      },
      data: data
    })
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response.data.message);
          setLinkAccount("");
          Getlinkaccounts();
          setOpenLink(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setPlayerList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPlayerStatus = () => {
    let url = `${endPoints.api.playerStatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        console.log("data", data);
        if (status === "success") {
          setPlayerStatusList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getAccountStatus = () => {
    let url = `${endPoints.api.accountstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setAccountList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAccountTypes = () => {
    let url = `${endPoints.api.accountstatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setAccountTypeList(data);

        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkAccName = (id) => {
    switch (id) {
      case 0:
        return "FINANCIAL";
      case 1:
        return "ADMIN";
      case 2:
        return "TEST USER";
      case 3:
        return "OPERATOR";
      case 4:
        return "AGENCY";
      case 5:
        return "REAL USER";
      default:
        return id;
    }

  }

  const Getlinkaccounts = () => {
    let url = `${endPoints.apiBaseUrl}${endPoints.api.GET_LINK_ACCOUNT}/${params.userId}`;
    // console.log("url",url);
    fetchAllData(url)
      .then((res) => res.json())
      .then((response) => {
        // console.log('response',response)
        setGetAccount(response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };


  const handleLinkAccount = () => {
    let url = `${endPoints.api.LINK_ACCOUNT}`;
    let data = {
      id_user: userObject?.account?.userId,
      link_Id: linkAccount,
    }
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          setLinkAccount("");
          Getlinkaccounts();
          setOpenLink(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const onClose = () => {
    setAddnote(false);
    Getnotes();
  };

  const handleCloselink = () => {

    setOpenLink(false);
    setLinkAccount("")
  }

  useEffect(() => {

    Getlinkaccounts();

  }, []);


  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div className="container-fluid bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div className="col-md-12">
                <h2 className="mb-2">Users</h2>
              </div>
            </div>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={tabvalue}>
                <Box sx={{ borderBottom: ~1, borderColor: 'divider' }}>
                  <TabList onChange={handleTabChange} >
                    <Tab label="DFS" value="1" />
                    {/* <Tab label="CASINO" value="3" /> */}
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <div id="Sportbook" style={{ padding: "0px" }}>
                    <div className="container-fluid bgwhite-radius">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="user1-info">
                            <h4 className="dark-gray f-bold mb-4">
                              {userObject?.name} {userObject?.surname}
                            </h4>
                            <p className="darkgray f-bold mb-1">
                              Username:{" "}
                              <span className="light-blue">{userObject?.login}</span>
                            </p>
                            <p className="align-right s-size">
                              {" "}
                              <span class="green-color f-bold">
                                Balance :{" "}
                              </span>{" "}
                              <span class="darkgray">
                                {userObject?.account?.balance}
                              </span>
                            </p>
                            <div className="d-flex justify-content-between gap-2">
                              <p className="mb-0 darkgray f-bold">
                                Customer ID :
                                <span className="black-color">
                                  {userObject?.idUser}
                                </span>
                              </p>
                              <p className="align-right mt-2 mb-1 s-size">
                                {" "}
                                <span class="green-color f-bold">
                                  Bonus Balance :{" "}
                                </span>{" "}
                                <span class="darkgray">
                                  {userObject?.account?.bonusBalance}
                                </span>
                              </p>

                            </div>
                            <hr className="gray-hr" />
                            <div className="account-demo">
                              <div className="d-flex justify-content-between gap-2">
                                <p className="darkgray f-bold mb-3">
                                  Account Status:{" "}
                                  <span
                                    className="green-color"
                                    onClick={() => {
                                      setAccountDialog(true);
                                    }}
                                  >
                                    {accountValue}
                                    <span>
                                      <GrEdit />
                                    </span>
                                  </span>
                                </p>

                                <p className="dark-gray f-bold">KYC Status:  <span className="green-color f-bold">{kycValue} </span></p>
                                <p className="darkgray">
                                  <span
                                    onClick={() => {
                                      setKYCDialog(true);
                                    }}
                                  >
                                    <GrEdit />
                                  </span>
                                </p>
                              </div>

                              <div className="d-flex justify-content-between gap-2">
                                <p className="darkgray f-bold">
                                  <span className="f-bold">DOB : </span>{" "}
                                  <span className="normal-w">
                                    {userObject?.birthDate}
                                  </span>{" "}
                                  |{" "}
                                  <span className="gender-info normal-w">
                                    {userObject?.sex}
                                  </span>
                                </p>
                                <p className="darkgray f-bold">
                                  Acc Type:{" "}
                                  <span className="green-color f-bold"
                                    onClick={() => {
                                      if (state.auth?.user?.data?.type == 1) {
                                        setUserAccDialog(true);
                                        //  console.log('userObject?.type',userObject?.type)
                                        setUserAccValue(userObject?.type)
                                      }
                                    }}
                                  >
                                    {state.auth?.user?.data?.type == 1 ? <GrEdit /> : null}
                                    {checkAccName(userObject?.type)}</span>
                                </p>
                              </div>

                              <div className="d-flex justify-content-between gap-2">
                                <p className="mb-0 darkgray f-bold">
                                  State:{" "}
                                  <span className="black-color f-bold">
                                    {userObject?.stateName}
                                  </span>
                                </p>
                                <p className="align-right s-size">
                                  {" "}
                                  <span class="darkgray f-bold">
                                    Last Login :{" "}
                                  </span>{" "}
                                  <span class="darkgray">02/13/2022</span>
                                </p>
                              </div>

                              <p className="darkgray f-bold">
                                Linked Accounts :{" "}
                                <span className="darkblur-color">
                                  <a onClick={() => setOpenLink(true)}>
                                    {getAccount?.length} linked Accounts
                                  </a>
                                </span>
                              </p>
                            </div>



                            <div className="heading mt-3">
                              <h5>Notes</h5>
                            </div>
                            <div className="gray-bg-border mt-3">
                              <div className="gap-2" style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
                                <NotesList
                                  alldata={alldata}
                                  state={state}
                                  setAddnote={setAddnote}
                                  setEditData={setEditData}
                                  DeleteNote={DeleteNote}
                                />
                              </div>

                              <div className="row" style={{ borderBottom: "2px solid gray", marginTop: "8px", marginBottom: "6px" }}></div>
                              <Button
                                variant="primary"
                                style={{ marginLeft: "100px", padding: "5px", marginTop: "5px" }}
                                onClick={() => {
                                  setAddnote(true);
                                  setEditData([]);
                                }}
                              >
                                Add Note
                              </Button>
                              <AddNote
                                open={addnote}
                                onClose={onClose}
                                editData={editData}
                                userid={userObject.account?.userId}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-9">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="gray-bg-border">
                                <div className="d-flex justify-content-between gap-2">
                                <div className="row">
                                <div className="col-md-6"> 
                                <div style={{display:'flex'}}>

                           
                                  <h6 className="dark-gray f-bold">Day Limit:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setDayLimitDialog(true);
                                      }}
                                      style={{marginLeft:'10px'}}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  </div>
                                  <h6 className="red-color" style={{ marginRight: '60px' }}>$ {userObject?.betLimit?.day_limit || dailyLimit}</h6>
                                 </div>

                                  <div className="col-md-6">
                                  <div style={{display:'flex'}}>
                                  <h6 className="dark-gray f-bold">CRS Limit:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setCRSLimitDialog(true)
                                      }}
                                      style={{marginLeft:'10px'}}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  </div>
                                  <h6 className="red-color">{userObject?.betLimit?.crs_limit || crsLimit}</h6>
                                  </div>

                                  <div className="row">
                                 <div className="col-md-6">
                                 <div style={{display:'flex'}}>
                                  <h6 className="dark-gray f-bold">Player Type:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setPlayerDialog(true);
                                      }}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  </div>
                                  <h6 className="red-color">{playerValue}</h6>
                                  </div>

                                  <div className="col-md-6">
                                  <div style={{display:'flex'}}>
                                  <h6 className="dark-gray f-bold">Player Status:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                     
                                        setPlayerStatusModal(true);
                                      }}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  </div>
                                  <h6 className="red-color">{playerStatusValue}</h6>
                                  </div>
                                 </div>
                                </div>
                                </div>
                               
                                {/* <div className="d-flex justify-content-between gap-2">
                                  <h6 className="red-color">{playerValue}</h6>
                                  <h6 className="red-color">{userObject?.betLimit?.crs_limit || crsLimit}</h6>
                                  <h6 className="red-color" style={{ marginRight: '60px' }}>$ {userObject?.betLimit?.day_limit || dailyLimit}</h6>
                                </div> */}
                                
                              </div>
                              <ContactInfo userObject={userObject} />
                              <SecurityQuestion
                                setQuesDialog={setQuesDialog}
                                questionValue={questionValue}
                                ansValue={ansValue}
                              />
                            </div>

                            <div className="col-md-8">
                              <RGLimits
                                setOpenRGLimit={setOpenRGLimit}
                                userObject={userObject}
                                rgLimitList={rgLimitList}
                              />
                              <Transactions
                                transArr={transArr}
                                page={page?page:0}
                                rowsPerPage={rowsPerPage}
                                totalCount={totalCount?totalCount:0}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                              />

                              <ReferFriendHistory userId={params.userId} />
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                            <div className="col-md-6">
                             <P2PBetsCompetition
                              p2pbetArr={p2pbetArr}
                            />
                            </div>

                            <div className="col-md-6">
                             <BetsCompetition
                              betArr={betArr}
                            />
                    </div>
                      </div>
                    </div>
                  </div>
                  

                  {openlink && (
                    <Modal
                      show={openlink}
                      onHide={handleCloselink}
                      times
                      size="xs"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      divider
                    >
                      {/* <Modal.Header> */}
                      <Modal.Title style={{ padding: "5px", borderBottom: "1px solid #e2e2e2" }}>
                        <p style={{ textAlign: "center", marginTop: "3px" }}>Link Account</p>
                      </Modal.Title>
                      {/* </Modal.Header> */}
                      <Modal.Body>
                        <h5>
                          Link Account Id's:
                        </h5>
                        <ol>
                          {getAccount.map((item) => (
                            <li>
                              <div className="row">
                                <div className="col-md-3">
                                  <h6>
                                    {item.link_Id == userObject?.idUser ? item.id_user : item.link_Id}
                                    {/* {item.link_Id} */}
                                  </h6>
                                </div>
                                <div className="col-md-2">
                                  <h6>
                                    {item?.name}
                                  </h6>
                                </div>
                                <div className="col-md-4">
                                  <h6>
                                    {item?.surname}
                                  </h6>
                                </div>
                                <div className="col-md-2" style={{ textAlign: "end", cursor: "pointer" }}>
                                  <span
                                    onClick={() => {
                                      RemoveLinkAccount(item.id_user, item.link_Id);
                                    }}
                                  >
                                    <Delete />
                                  </span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ol>
                        <FormControl style={{ width: "100%", marginTop: "10px" }}>
                          <label>Enter Account No</label>
                          <TextField
                            id="filled-required"
                            variant="outlined"
                            placeholder="Enter Account No"
                            type="text"
                            value={linkAccount}
                            onChange={(event) => {
                              setLinkAccount(event.target.value);
                            }}
                          />
                        </FormControl>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloselink}>
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleLinkAccount}>
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}

                  <AccountStatusDialog
                    id="ringtone-menu"
                    keepMounted
                    open={accountDialog}
                    onClose={handleClose}
                    value={accountValue}
                    accountList={accountList}
                    accountReason={accountReason}
                  />
                  <AccountTypeDialog
                    keepMounted
                    open={userAccDialog}
                    onClose={handleAccountTypeClose}
                    value={userAccValue}
                    accountTypeList={accountTypeList}
                  />

                  <PlayerTypeDialog
                    keepMounted
                    open={playerDialog}
                    onClose={handlePlayerTypeeClose}
                    value={playerValue}
                    playerList={playerList}
                  />
                  <PlayerStatusDialog
                    keepMounted
                    open={playerStatusModal}
                    onClose={handlePlayerStatusClose}
                    value={playerStatusValue}
                    playerStatusList={playerStatusList}
                  />
               
                  <KycTypeDialog
                    keepMounted
                    open={KYCDialog}
                    onClose={handleKycTypeClose}
                    value={kycValue}
                    playerList={kycList}
                  />
                  <QuestionDialog
                    keepMounted
                    open={quesDailog}
                    onClose={handleQuestionClose}
                    value={questionValue}
                    ansValue={ansValue}
                    playerList={questionArr}
                  />
                  <CRSTypeDialog
                    keepMounted
                    open={crsLimitDialog}
                    onClose={handleCRSClose}
                    value={userObject?.betLimit?.crs_limit || crsLimit}
                  />
                  <DailyLimitTypeDialog
                    keepMounted
                    open={dayLimitDialog}
                    onClose={handleDailyLimitClose}
                    value={userObject?.betLimit?.day_limit || dailyLimit}
                  />
                  <AddressInfoDialog
                    keepMounted
                    open={addressDialog}
                    onClose={handleAddressClose}
                    userObject={userObject}
                  // value={questionValue}
                  // ansValue={ansValue}
                  // playerList={questionArr}
                  />

                  <RGLimitDialogRaw
                    id="ringtone-menu"
                    keepMounted
                    open={openRGLimit}
                    onClose={handleRGLimitClose}
                    updateBet={handleBetClick}
                    updateDeposit={handleDepositClick}
                    userObject={userObject}

                    coolOffUser={coolOffUserClick}
                    excludeUser={excludeUserClick}
                  // value={value}
                  />

                </TabPanel>
                {/* <TabPanel value="2">
                  <div id="Sportbook" style={{ padding: "0px" }}>
                    <div className="container-fluid bgwhite-radius">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="user1-info">
                            <h4 className="dark-gray f-bold mb-4">
                              {userObject?.name} {userObject?.surname}
                            </h4>
                            <p className="darkgray f-bold mb-1">
                              Username:{" "}
                              <span className="light-blue">{userObject?.login}</span>
                            </p>
                            <p className="align-right s-size">
                              {" "}
                              <span class="green-color f-bold">
                                Balance :{" "}
                              </span>{" "}
                              <span class="darkgray">
                                {userObject?.account?.balance}
                              </span>
                            </p>
                            <div className="d-flex justify-content-between gap-2">
                              <p className="mb-0 darkgray f-bold">
                                Customer ID :
                                <span className="black-color">
                                  {userObject?.idUser}
                                </span>
                              </p>
                              <p className="align-right mt-2 mb-1 s-size">
                                {" "}
                                <span class="green-color f-bold">
                                  Bonus Balance :{" "}
                                </span>{" "}
                                <span class="darkgray">
                                  {userObject?.account?.bonusBalance}
                                </span>
                              </p>

                            </div>
                            <hr className="gray-hr" />
                            <div className="account-demo">
                              <div className="d-flex justify-content-between gap-2">
                                <p className="darkgray f-bold mb-3">
                                  Account Status:{" "}
                                  <span
                                    className="green-color"
                                    onClick={() => {
                                      setAccountDialog(true);
                                    }}
                                  >
                                    {accountValue}
                                    <span>
                                      <GrEdit />
                                    </span>
                                  </span>
                                </p>

                                <p className="dark-gray f-bold">KYC Status:  <span className="green-color f-bold">{kycValue} </span></p>
                                <p className="darkgray">
                                  <span
                                    onClick={() => {
                                      setKYCDialog(true);
                                    }}
                                  >
                                    <GrEdit />
                                  </span>
                                </p>
                              </div>

                              <div className="d-flex justify-content-between gap-2">
                                <p className="darkgray f-bold">
                                  <span className="f-bold">DOB : </span>{" "}
                                  <span className="normal-w">
                                    {userObject?.birthDate}
                                  </span>{" "}
                                  |{" "}
                                  <span className="gender-info normal-w">
                                    {userObject?.sex}
                                  </span>
                                </p>
                                <p className="darkgray f-bold">
                                  Acc Type:{" "}
                                  <span className="green-color f-bold"
                                    onClick={() => {
                                      if (state.auth?.user?.data?.type == 1) {
                                        setUserAccDialog(true);
                                      
                                        setUserAccValue(userObject?.type)
                                      }
                                    }}
                                  >
                                    {state.auth?.user?.data?.type == 1 ? <GrEdit /> : null}
                                    {checkAccName(userObject?.type)}</span>
                                </p>
                              </div>

                              <div className="d-flex justify-content-between gap-2">
                                <p className="mb-0 darkgray f-bold">
                                  State:{" "}
                                  <span className="black-color f-bold">
                                    {userObject?.stateName}
                                  </span>
                                </p>
                                <p className="align-right s-size">
                                  {" "}
                                  <span class="darkgray f-bold">
                                    Last Login :{" "}
                                  </span>{" "}
                                  <span class="darkgray">02/13/2022</span>
                                </p>
                              </div>

                              <p className="darkgray f-bold">
                                Linked Accounts :{" "}
                                <span className="darkblur-color">
                                  <a onClick={() => setOpenLink(true)}>
                                    {getAccount?.length} linked Accounts
                                  </a>
                                </span>
                              </p>
                            </div>



                            <div className="heading mt-3">
                              <h5>Notes</h5>
                            </div>
                            <div className="gray-bg-border mt-3">
                              <div className="gap-2" style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
                                <NotesList
                                  alldata={alldata}
                                  state={state}
                                  setAddnote={setAddnote}
                                  setEditData={setEditData}
                                  DeleteNote={DeleteNote}
                                />
                              </div>

                              <div className="row" style={{ borderBottom: "2px solid gray", marginTop: "8px", marginBottom: "6px" }}></div>
                              <Button
                                variant="primary"
                                style={{ marginLeft: "100px", padding: "5px", marginTop: "5px" }}
                                onClick={() => {
                                  setAddnote(true);
                                  setEditData([]);
                                }}
                              >
                                Add Note
                              </Button>
                              <AddNote
                                open={addnote}
                                onClose={onClose}
                                editData={editData}
                                userid={userObject?.account?.userId}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-9">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="gray-bg-border">
                                <div className="d-flex justify-content-between gap-2">
                                  <h6 className="dark-gray f-bold">Player Type:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setPlayerDialog(true);
                                      }}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  <h6 className="dark-gray f-bold">CRS Limit:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setCRSLimitDialog(true)
                                      }}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                  <h6 className="dark-gray f-bold">Day Limit:</h6>
                                  <h6 className="darkgray">
                                    <span
                                      onClick={() => {
                                        setDayLimitDialog(true);
                                      }}
                                    >
                                      <GrEdit />
                                    </span>
                                  </h6>
                                </div>
                                <div className="d-flex justify-content-between gap-2">
                                  <h6 className="red-color">{playerValue}</h6>
                                  <h6 className="red-color">{userObject?.betLimit?.crs_limit || crsLimit}</h6>
                                  <h6 className="red-color" style={{ marginRight: '60px' }}>$ {userObject?.betLimit?.day_limit || dailyLimit}</h6>
                                </div>
                              </div>
                              <ContactInfo userObject={userObject} />
                              <SecurityQuestion
                                setQuesDialog={setQuesDialog}
                                questionValue={questionValue}
                                ansValue={ansValue}
                              />
                            </div>

                            <div className="col-md-8">
                              <RGLimits
                                setOpenRGLimit={setOpenRGLimit}
                                userObject={userObject}
                                rgLimitList={rgLimitList}
                              />
                              <Transactions
                                transArr={transArr}
                              />
                            </div>
                            <BetsCompetition
                              betArr={betArr}
                             
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  

                  {openlink && (
                    <Modal
                      show={openlink}
                      onHide={handleCloselink}
                      times
                      size="xs"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      divider
                    >
                    
                      <Modal.Title style={{ padding: "5px", borderBottom: "1px solid #e2e2e2" }}>
                        <p style={{ textAlign: "center", marginTop: "3px" }}>Link Account</p>
                      </Modal.Title>
                     
                      <Modal.Body>
                        <h5>
                          Link Account Id's:
                        </h5>
                        <ol>
                          {getAccount.map((item) => (
                            <li>
                              <div className="row">
                                <div className="col-md-3">
                                  <h6>
                                    {item?.link_Id == userObject?.idUser ? item.id_user : item.link_Id}
                                  
                                  </h6>
                                </div>
                                <div className="col-md-2">
                                  <h6>
                                    {item?.name}
                                  </h6>
                                </div>
                                <div className="col-md-4">
                                  <h6>
                                    {item?.surname}
                                  </h6>
                                </div>
                                <div className="col-md-2" style={{ textAlign: "end", cursor: "pointer" }}>
                                  <span
                                    onClick={() => {
                                      RemoveLinkAccount(item?.id_user, item?.link_Id);
                                    }}
                                  >
                                    <Delete />
                                  </span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ol>
                        <FormControl style={{ width: "100%", marginTop: "10px" }}>
                          <label>Enter Account No</label>
                          <TextField
                            id="filled-required"
                            variant="outlined"
                            placeholder="Enter Account No"
                            type="text"
                            value={linkAccount}
                            onChange={(event) => {
                              setLinkAccount(event.target.value);
                            }}
                          />
                        </FormControl>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloselink}>
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleLinkAccount}>
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}

                  <AccountStatusDialog
                    id="ringtone-menu"
                    keepMounted
                    open={accountDialog}
                    onClose={handleClose}
                    value={accountValue}
                    accountList={accountList}
                  />
                  <AccountTypeDialog
                    keepMounted
                    open={userAccDialog}
                    onClose={handleAccountTypeClose}
                    value={userAccValue}
                    accountTypeList={accountTypeList}
                  />

                  <PlayerTypeDialog
                    keepMounted
                    open={playerDialog}
                    onClose={handlePlayerTypeeClose}
                    value={playerValue}
                    playerList={playerList}
                  />
                
                  <KycTypeDialog
                    keepMounted
                    open={KYCDialog}
                    onClose={handleKycTypeClose}
                    value={kycValue}
                    playerList={kycList}
                  />
                  <QuestionDialog
                    keepMounted
                    open={quesDailog}
                    onClose={handleQuestionClose}
                    value={questionValue}
                    ansValue={ansValue}
                    playerList={questionArr}
                  />
                  <CRSTypeDialog
                    keepMounted
                    open={crsLimitDialog}
                    onClose={handleCRSClose}
                    value={userObject?.betLimit?.crs_limit || crsLimit}
                  />
                  <DailyLimitTypeDialog
                    keepMounted
                    open={dayLimitDialog}
                    onClose={handleDailyLimitClose}
                    value={userObject?.betLimit?.day_limit || dailyLimit}
                  />
                  <AddressInfoDialog
                    keepMounted
                    open={addressDialog}
                    onClose={handleAddressClose}
                    userObject={userObject}
                  />

                  <RGLimitDialogRaw
                    id="ringtone-menu"
                    keepMounted
                    open={openRGLimit}
                    onClose={handleRGLimitClose}
                    updateBet={handleBetClick}
                    updateDeposit={handleDepositClick}
                    userObject={userObject}

                    coolOffUser={coolOffUserClick}
                    excludeUser={excludeUserClick}
                  
                  />

                </TabPanel> */}
              </TabContext>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDetails;
